import React from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';
import { MdErrorOutline } from 'react-icons/md';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import styled from 'styled-components';

// `options` repassa para o react-toastify (ex.: { autoClose: false } para uma
// mensagem longa que o usuário precisa ler — FEAT-019, fotos recusadas).
export const toastError = (title, text, options = {}) => {
  const message = () => (
    <Container>
      <div className="icon">
        <MdErrorOutline size={22} />
      </div>
      <div className="classWithFontStyleOrWhatever">
        <p>{title || 'Erro!'} </p>
        {text}
      </div>
    </Container>
  );

  return toast.error(message, {
    toastId: 1,
    ...options,
  });
};

export const toastSuccess = (title, text) => {
  const message = () => (
    <Container>
      <div className="icon">
        <FaRegCheckCircle size={22} />
      </div>
      <div className="classWithFontStyleOrWhatever">
        <p>{title || 'Sucesso!'}</p>
        {text}
      </div>
    </Container>
  );

  return toast.success(message);
};

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  p {
    font-size: 15px;
    font-weight: bold;
    margin: 0;
  }

  .icon {
    margin: 10px;
    /* padding: 20px; */
    border-right: 2px solid #fff;

    svg {
      margin-right: 10px;
    }
  }
`;
